<template >
    <section class=" flex flex-col justify-center items-center ThanksBg w-full bg-cover bg-no-repeat px-18px py-41 md:py-254px ">
                <section class="rounded-2.5 md:max-w-133.25 lg:max-w-162 thanksBox  ">
                        <section class=" md:px-20 text-center flex flex-col items-center ">
                            <section class="flex flex-col items-center">
                                <img class="max-w-25 pt-42"  src="../../../../v2/src/assets/images/icons/recurso_signos.svg" alt="">
                                <h1 class="text-30px text-left md:text-10 font-bold pt-7" :class="{'text-center': isMobile}"> ¡ Felicidades !</h1>
                                <section class="lg:border-b pt-3 w-300px border-black" />
                            </section>
                            <section class="text-center pt-34px px-47px md:px-0 text-blacky  md:text-big leading-22px">
                                <p class="">Acabas de dar gran paso para cuidar tu alimentación </p>
                                <p class="pt-6">Celebro de todo corazón tu decisión a dar el paso hacia una vida llena de salud al registrarte, entrarás al grupo de telegram para darte los avisos cuando vamos a comenzar, y en el grupo de facebook donde colocaras tus tareas y las revisaremos en vivo.</p>
                            </section>
                            <section class="w-full px-8 md:px-0 pt-8 pb-8">
                                <button @click="toBack" class="cursor-pointer w-full md:w-300px py-12px rounded-2.5 text-white font-semibold lg:max-w-75  transition duration-500 ease-in-out bg-btn2 hover:bg-yellow-600">Gracias</button>
                            </section>
                        </section>
                </section>
    </section>
</template>
<script>
import utilsMixin from "../../../../v2/src/mixins/utilsMixin"
export default {
    mixins: [utilsMixin],
    components :{
   },
    mounted(){
            if(localStorage.getItem("firstName") == null || localStorage.getItem("lastName") == null || localStorage.getItem("email") == null){
                this.$router.push({name: "10-obstaculos"})
            }
    },   
    methods: {
       toBack(){
        this.$router.push({
          name: "telemedicina-diabetes"
        })
       }
   },
}
</script>
<style>
.thanksBox{
    background: linear-gradient(16.78deg, rgba(255, 255, 255, 0.8) -12.17%, rgba(255, 255, 255, 0.35) 112.57%);
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.2);
}
.ThanksBg{
    background-image: url("../../../../v2/src/assets/images/DiabetesThanks.svg");
}
</style>